import Config from '../Config';
import { RestService } from './RestService';

export const ProductService = {
    getItemList: async function(organisation){
        return RestService.get(`${Config.get_items}organisation=${organisation}&`, {})
        .then(response => response.json());
    },
    create: async function(organisation, headers, body){
        return RestService.post(`${Config.create_item}organisation=${organisation}&`, headers, body);
        // .then(response => response.json());
    },
    remove: async function(organisation, headers, id){
        return RestService.get(`${Config.remove_item}organisation=${organisation}&id=${id}`, {});
        // .then(response => response.json());
    }
};